import { api, authHeaders } from '../api/api';

export interface SuggestedQuery {
  id: string;
  text: string;
  language_code: 'en' | 'ga';
  sort_order: number;
  is_active: boolean;
  created_at: string;
  created_by?: string;
  updated_at: string;
  updated_by?: string;
}

export interface CreateSuggestedQueryPayload {
  text: string;
  language_code: 'en' | 'ga';
  sort_order?: number;
  created_by?: string;
}

export interface UpdateSuggestedQueryPayload {
  text?: string;
  language_code?: 'en' | 'ga';
  sort_order?: number;
  is_active?: boolean;
  updated_by?: string;
}

export const suggestedQueryService = {
  getAllQueries: async (
    includeInactive = false,
    languageCode?: 'en' | 'ga',
  ): Promise<SuggestedQuery[]> => {
    const headers = await authHeaders();
    const response = await api.get<SuggestedQuery[]>(
      '/api/suggested-queries',
      {
        headers,
        params: {
          include_inactive: includeInactive,
          language_code: languageCode,
        },
      }
    );
    return response.data;
  },

  createQuery: async (payload: CreateSuggestedQueryPayload): Promise<SuggestedQuery> => {
    const headers = await authHeaders();
    const response = await api.post<SuggestedQuery>('/api/suggested-queries', payload, { headers });
    return response.data;
  },

  updateQuery: async (queryId: string, payload: UpdateSuggestedQueryPayload): Promise<SuggestedQuery> => {
    const headers = await authHeaders();
    const response = await api.put<SuggestedQuery>(
      `/api/suggested-queries/${queryId}`,
      payload,
      { headers }
    );
    return response.data;
  },

  deleteQuery: async (queryId: string): Promise<{ message: string }> => {
    const headers = await authHeaders();
    const response = await api.delete<{ message: string }>(
      `/api/suggested-queries/${queryId}`,
      { headers }
    );
    return response.data;
  },

  toggleQuery: async (queryId: string): Promise<SuggestedQuery> => {
    const headers = await authHeaders();
    const response = await api.put<SuggestedQuery>(
      `/api/suggested-queries/${queryId}/toggle`,
      undefined,
      { headers }
    );
    return response.data;
  },
};
